module.exports = __webpack_public_path__ + "img/010江南.57f18734.jpg";